// extracted by mini-css-extract-plugin
export default {"borderFooter":"ContactForm_borderFooter__MVbJS","blogSection":"ContactForm_blogSection__0BccA","error":"ContactForm_error__C1smZ"};